module.exports = __webpack_public_path__ + "static/media/view_store_logo.efcd19f5.png";